import { Checkbox } from "semantic-ui-react";

const Toggle = ({ onChange, value }) => {
  return <Checkbox toggle onChange={onChange} defaultChecked={value} />;
};

export default Toggle;
